import Link from 'next/link';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';

import s from './styles.scss';

const createMarkup = value => ({ __html: value });

const Content = ({
  call_us_phone_number,
  call_us_text,
  client_testimonials,
  footer_title,
  footer_cta_text,
  footer_button_text,
  handleVisible,
  link,
  need_help_text,
  package_info,
  ribbon_title,
  ribbon_button_text,
}) => (
  <div className={s.content}>
    <div className={s.unsure}>
      <div className={s.unsureCenter}>
        <span>{ribbon_title}</span>
        <Link href={link}>
          <a
            role="button"
            tabIndex={0}
            onClick={e => {
              const city = Cookies.get('city');
              const llc = Cookies.get('llc');
              if (!city && !llc) {
                e.preventDefault();
                handleVisible();
              }
            }}
            onKeyDown={e => {
              const city = Cookies.get('city');
              const llc = Cookies.get('llc');
              if (!city && !llc) {
                e.preventDefault();
                handleVisible();
              }
            }}
            className={s.button}
          >
            {ribbon_button_text}
          </a>
        </Link>
        <span className={s.callUs}>
          {call_us_text}&nbsp;
          <a
            href={`tel:${call_us_phone_number &&
              call_us_phone_number.replace(/\D/g, '')}`}
          >
            <h2>{call_us_phone_number}</h2>
          </a>
        </span>
      </div>
    </div>
    <div className={s.inPackage}>
      <div className={s.imgWrapper}>
        <img src="/static/packageImg.jpg" alt="our packages" />
      </div>
      <div
        className={s.packageText}
        dangerouslySetInnerHTML={createMarkup(package_info)}
      />
    </div>
    <div className={s.feedBack}>
      <div className={s.feedHead}>Our Clients Love Us:</div>
      {client_testimonials &&
        client_testimonials.map((e, i) => (
          <div className={s.feedBackItem} key={`${i} test`}>
            <div className={s.feedText}>{e.testimonial}</div>
            <div className={s.feedName}>{e.client}</div>
          </div>
        ))}
    </div>
    <div className={s.footer}>
      <div className={s.everything}>{footer_title}</div>
      <div className={s.create}>
        <div className={s.text}>
          <span>{footer_cta_text}</span>
        </div>
        <Link href={link}>
          <a
            role="button"
            tabIndex={0}
            onClick={e => {
              const city = Cookies.get('city');
              const llc = Cookies.get('llc');
              if (!city && !llc) {
                e.preventDefault();
                handleVisible();
              }
            }}
            onKeyDown={e => {
              const city = Cookies.get('city');
              const llc = Cookies.get('llc');
              if (!city && !llc) {
                e.preventDefault();
                handleVisible();
              }
            }}
            className={s.button}
          >
            {footer_button_text}
          </a>
        </Link>
      </div>
      <div className={s.needHelp}>
        <p>{need_help_text}</p>
        <a
          href={`tel:${call_us_phone_number &&
            call_us_phone_number.replace(/\D/g, '')}`}
        >
          <span>{call_us_phone_number}</span>
        </a>
      </div>
    </div>
  </div>
);

Content.propTypes = {
  call_us_phone_number: PropTypes.string,
  call_us_text: PropTypes.string,
  client_testimonials: PropTypes.array,
  footer_title: PropTypes.string,
  footer_cta_text: PropTypes.string,
  footer_button_text: PropTypes.string,
  handleVisible: PropTypes.func,
  link: PropTypes.string,
  need_help_text: PropTypes.string,
  package_info: PropTypes.string,
  ribbon_title: PropTypes.string,
  ribbon_button_text: PropTypes.string,
};

export default Content;
